// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"ProductGalleryMobile_sliderContainer__1bh7D","imageContainer":"ProductGalleryMobile_imageContainer__3GJZF","image":"ProductGalleryMobile_image__2cATj"};